import { createShortcutTarget } from '@/utils/shortcutTarget';

/** ⌘K: toggles the mounted MarketSelect's menu. False when none is on screen (Market panel hidden). */
export const marketMenuToggle = createShortcutTarget();

/** The one definition of the ⌘K / Ctrl+K key: the app binds it, the menu and its hint row show it. */
export const OPEN_MARKETS_SHORTCUT = { key: 'k', mod: true } as const;

/** On the menu's popover root, so the ⌘K gate can tell it apart from other open modals. */
export const MARKET_MENU_CLASS = 'market-menu';
